"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CheckIcon = function CheckIcon(_ref) {
  var color = _ref.color,
    width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    fill: color,
    stroke: color
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.19508 10.143L2.46001 5.51027L1 6.93874L7.19508 13L18 2.42847L16.54 1L7.19508 10.143Z"
  }));
};
CheckIcon.propTypes = _utils.iconProps;
CheckIcon.defaultProps = {
  color: 'white',
  width: '19',
  height: '14'
};
var _default = CheckIcon;
exports.default = _default;